<!--
렉 추가
------------------------------------
-->
<template>
    <div class="uk-flex-top" uk-modal esc-close="false" bg-close="false">
        <div class="uk-modal-dialog uk-margin-auto-vertical uk-width-xxlarge">

            <div class="uk-modal-header">
                <h4>렉 추가</h4>
            </div>

            <div class="uk-modal-body uk-padding-small " >
                <div class="uk-child-width-1-4 uk-margin-bottom" uk-grid>
                    <app-input-ex
                        type="select"

                        name="storage_type"
                        v-model="inputs.storage_type"
                        label="종류"

                        :validate-rules="{required: true}"
                        required
                        required-layout="label-left"

                        :options="storageTypeOptions"
                    > </app-input-ex>

                    <app-input-ex
                        type="text"

                        name="name"
                        v-model="inputs.name"
                        label="렉 이름"

                        :validate-rules="{required: true}"
                        required
                        required-layout="label-left"

                        placeholder=""
                    > </app-input-ex>

                    <app-input-ex
                        type="text"

                        name="floor"
                        v-model="inputs.floor"
                        label="층"

                        :validate-rules="{required: true}"
                        required
                        required-layout="label-left"

                        placeholder=""
                    > </app-input-ex>

                    <app-input-ex
                        type="text"

                        name="cell"
                        v-model="inputs.cell"
                        label="칸"

                        :validate-rules="{required: true}"
                        required
                        required-layout="label-left"

                        placeholder=""
                    > </app-input-ex>
                </div>

                <!-- 예시 -->
                <div class="uk-text-center">
                    생성되는 보관장소 예시 :
                    <span class="uk-text-primary uk-text-large">
                        {{ inputs.name }}-{{ inputs.floor }}F-{{ inputs.cell }}
                    </span>
                </div>

            </div>


            <div class="uk-modal-footer uk-text-right">
                <!--- 버튼 -->
                <button
                    type="button"
                    class="uk-button uk-button-default uk-modal-close"
                >
                    <span uk-icon="icon: close"></span> 취소
                </button>
                <button
                    type="button"
                    class="uk-button uk-button-primary"
                    v-on:click="submit()"
                >
                    <span uk-icon="icon: check"></span>
                    완료
                </button>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            // csrf-token
            csrfToken: String,

            /**
             * 지역ID
             */
            regionId: Number,

            /**
             * 보관장소종류 코드표 배열
             */
            storageTypeOptions: Array,
        },
        data: function () {
            return {
                // 입력값 object
                inputs: {
                    storage_type: '1',
                    name: null,
                    floor: null,
                    cell: null,
                },
            };
        },
        computed: {
        },
        methods: {
            /**
             * 입력폼 display
             */
            displayForm() {
                UIkit.modal(this.$el).show();
            },

            /**
             * 폼
             */
            form() {

                // 폼띄우기
                this.displayForm();
            },


            /**
             * submit
             */
            submit() {

                // ajax 옵션
                let opts = {
                    type: 'post',
                    url: '/racks',
                    data: _.merge({
                        '_token': this.csrfToken,
                        'region_id': this.regionId,
                    }, this.inputs),
                    success: (response, textStatus, jqXHR) => {
                        UIkit.modal.alert(response.msg).then(function () {
                            $.app.refresh();
                        });
                    },
                };

                // ajax 실행
                $.app.ajax.module.default(opts);
            },
        },
    }
</script>

<style lang="scss" scoped>
</style>